import { connect } from 'react-redux';

// @ts-nocheck
import { IncidentsPopup } from './IncidentsPopup';
import type { Dispatch } from 'redux';

import {
  INCIDENTS_REQUEST_AMOUNT,
  type IncidentWithAddress,
  type TimestampInMillis,
} from '@cobliteam/common-types';

import type { WebData } from '@cobliteam/api-lib';

import {
  type AppState,
  loadAlarmsRequest,
  selectIncidents,
} from '@cobliteam/store';

interface OwnProps {
  handleExportClick: () => void;
}

interface StateProps {
  incidentsWebData: WebData<IncidentWithAddress[]>;
}

interface DispatchProps {
  loadIncidents: (endDate: TimestampInMillis) => void;
}

const mapStateToProps = (state: AppState): StateProps => ({
  incidentsWebData: selectIncidents(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  loadIncidents: (endDate) => {
    const alarmsPayload = {
      endTime: endDate,
      amount: INCIDENTS_REQUEST_AMOUNT,
    };

    dispatch(loadAlarmsRequest(alarmsPayload));
  },
});

export const IncidentsPopupContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  AppState
>(
  mapStateToProps,
  mapDispatchToProps
)(IncidentsPopup);
